<template>
  <div>
    <template v-if="window.size.desktop">
      <Transition name="fade">
        <div v-if="sortingMenuOpened">
          <div class="z-backdrop fixed left-0 top-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto !bg-black/40"></div>
          <div class="w-screen h-fit left-0 right-0 bottom-0 rounded-zt bg-zt-normal z-modal text-[16px] font-normal 
                 shadow-zt absolute top-[150%] max-w-[360px] -translate-x-[182px] translate-y-0 overflow-y-visible sort-modal"
               v-click-outside="sortingClickOutside">
            <div v-for="(sortOption, index) in sortingOptions" :key="index">
              <div v-if="!sortOption.onlyAdmin || (sortOption.onlyAdmin && userCanSettle)"
                   class="sort-item"
                   :class="{ 'bg-zt-light before:bg-zt-red': 
                     sortOption.type2
                       ? sortingType === sortOption.type && secondarySortingType === sortOption.type2
                       : sortingType === sortOption.type 
                    }"
                   @click="selectSortingType(sortOption)">
                <div class="flex flex-nowrap">
                  {{ sortOption.label }}
                  <div class="w-[26px] ml-1 flex items-center justify-center">
                    <svg
                        :class="{ 'rotate-180' : sortOption.reverse }"
                        v-show="sortOption.type2 ? sortingType === sortOption.type && secondarySortingType === sortOption.type2 : sortingType === sortOption.type"
                         width="10" height="12" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.75348 12.1872L5.75347 -3.20163e-07L7.24653 -4.5069e-07L7.24653 12.1872L11.9444 7.56319L13 8.60218L6.5 15L3.94359e-07 8.60218L1.05559 7.56319L5.75348 12.1872Z" fill="white" />
                    </svg>
                  </div>
                  <div v-if="sortOption.type === 'recommended'" class="bg-zt-red rounded-zt px-1 py-0.5 !text-xs text-center h-[80%] mt-0.5 font-semibold">
                    <span>NEW</span>
                  </div>
                </div>
                <span class="text-left text-[12px] font-light text-zt-more">{{ sortOption.description }}</span>
              </div>
            </div>
          </div>
        </div>
      </Transition>
    </template>
    <template v-else>
      <div v-if="sortingMenuOpened">
        <div class="fixed w-screen h-full left-0 right-0 top-0 bottom-0 rounded-zt bg-zt-normal z-modal text-[16px] font-normal
              shadow-zt overflow-y-auto filter-panel-scroll"
            v-click-outside="sortingClickOutside">
          <div class="relative py-4 px-5 border-b-[1px] border-[#313A44] flex flex-nowrap justify-start items-center">
            <span class="font-medium">Sortowanie</span>
            <div class="x-close-modal" @click.stop="toggleSort()"></div>
          </div>
          <div class="flex flex-col h-[calc(100%-57px)] overflow-y-auto">
            <div class="flex-1">
              <div v-for="(sortOption, index) in sortingOptions" :key="index">
                <div v-if="!sortOption.onlyAdmin || (sortOption.onlyAdmin && userCanSettle)"
                    class="sort-item"
                    :class="{ 'bg-zt-light before:bg-zt-red':
                      sortOption.type2
                        ? sortingType === sortOption.type && secondarySortingType === sortOption.type2
                        : sortingType === sortOption.type
                    }"
                    @click="selectSortingType(sortOption)">
                  <div class="flex flex-nowrap">
                    {{ sortOption.label }}
                    <div class="w-[26px] ml-1 flex items-center justify-center">
                      <svg :class="{ 'rotate-180' : sortOption.reverse }"
                          v-show="sortOption.type2 ? sortingType === sortOption.type && secondarySortingType === sortOption.type2 : sortingType === sortOption.type"
                          width="10" height="12" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.75348 12.1872L5.75347 -3.20163e-07L7.24653 -4.5069e-07L7.24653 12.1872L11.9444 7.56319L13 8.60218L6.5 15L3.94359e-07 8.60218L1.05559 7.56319L5.75348 12.1872Z" fill="white" />
                      </svg>
                    </div>
                    <div v-if="sortOption.type === 'recommended'" class="bg-zt-red rounded-zt px-1 py-0.5 !text-xs text-center h-[80%] mt-0.5 font-semibold">
                      <span>NEW</span>
                    </div>
                  </div>
                  <span class="text-left text-[12px] font-light text-zt-more">{{ sortOption.description }}</span>
                </div>
              </div>
            </div>
            <div class="px-5">
              <button class="px-4 py-3 mt-3 mb-4 bg-zt-light border-zt-light rounded-zt zt-hover w-full xl:w-[366px]" @click.stop="toggleSort()">
                <span class="text-sm font-semibold">ZAMKNIJ OKNO</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import utils_mixin from '../../mixins/utils_mixin.js';

export default {
  name: 'BetSortModal',
  inject: ['WP'],
  mixins: [utils_mixin],
  emits: ['toggleSort', 'sortBets'],
  props: {
    sortingMenuOpened: {
      type: Boolean,
      required: true
    },
    sortingClickOutside: {
      type: Object,
      required: true
    },
    sortingType: {
      type: String,
      required: true
    },
    secondarySortingType: {
      type: String,
      required: false
    },
    isBetDiscussionSort: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      userCanSettle: false,
      sortingOptions: [],
      betOptions: [
        { type: 'likes', type2: '', label: 'Popularność typu', description: '', reverse: false, analytic: 'TD - sortowanie → Popularność typu' },
        { type: 'efficiency', type2: '', label: 'Skuteczność Typera', description: '', reverse: false, analytic: 'TD - sortowanie → Skuteczność Typera' },
        { type: 'date', type2: '', label: 'Godzina dodania', description: '', reverse: false, analytic: 'TD - sortowanie → Godzina dodania' },
        { type: 'matchTime', type2: '', label: 'Godzina spotkania', description: '', reverse: false, analytic: 'TD - sortowanie → Godzina spotkania' },
        { type: 'ratio', type2: '', label: 'Kurs', description: '', reverse: false, analytic: 'TD - sortowanie → Kurs' },
        { type: 'settled', type2: 'hour', label: 'Nierozliczonych - godzina', description: '', onlyAdmin: true, reverse: false },
        { type: 'settled', type2: 'discipline', label: 'Nierozliczonych - dyscyplina', description: '', onlyAdmin: true, reverse: false },
        { type: 'recommended', type2: '', label: 'Wybrane dla Ciebie', description: 'Najczęściej na górze pojawiają się typy popularnych i skutecznych Typerów oraz obszerne analizy, jak i te, które zyskują dużą ilość polubień.',
          onlyAdmin: false, reverse: false, analytic: 'TD - sortowanie → Wybrane dla Ciebie'},
      ],
      betDiscussionOptions: [
        { type: 'newest', label: 'Najnowsze' },
        { type: 'oldest', label: 'Najstarsze' }
      ],
      selectedSorting: {}
    };
  },
  mounted() {
    this.userCanSettle = this.WP.user.role === 'Admin' || this.WP.user.role === 'Moderator';
    this.sortingOptions = this.isBetDiscussionSort ? this.betDiscussionOptions : this.betOptions;
    this.selectedSorting = this.sortingOptions[0];
  },
  methods: {
    toggleSort() {
      this.$emit('toggleSort');
    },
    sortBets(sortingType, secondarySortingType, reverse = false) {
      if (this.isBetDiscussionSort) {
        this.$emit('sortBets', sortingType);
      } else {
        this.$emit('sortBets', false, sortingType, secondarySortingType, reverse);
      }
    },
    selectSortingType(sortOption) {
      if (sortOption.analytic) {
        this.countClicks(sortOption.analytic, 'bets', 0 , true);
      }
      this.unblockScrolling();
      if (this.selectedSorting.type === sortOption.type && sortOption.type !== 'recommended') {
        this.selectedSorting.reverse = !this.selectedSorting.reverse;
      } else {
        this.selectedSorting = sortOption;
        this.selectedSorting.reverse = false;
      }
      this.selectedSorting = sortOption;
      this.sortBets(sortOption.type, sortOption.type2, sortOption.reverse);
    }
  }
};
</script>

<style scoped>
.sort-item {
  @apply relative py-4 px-5 border-b border-zt-light flex flex-col justify-start cursor-pointer
  last:border-b-0 first:rounded-t-zt last:rounded-b-zt hover:bg-zt-light;
}

.sort-item:before {
  @apply content-[''] w-[3px] left-0 top-1/2 -translate-y-1/2 h-[70%] absolute rounded-zt;
}

.sort-modal:after {
  @apply content-[''] absolute -top-[16px] right-[24px] w-0 h-0 border-b-zt-normal border-b-[16px] border-x-transparent border-x-[8px];
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-move{
  transition: all .7s ease-in-out;
}
</style>
